import { tencentMapKeys } from '../map';
let geolocation = null;

function initTencentLocation(tencentMapKey = 'siteCodeGeo') {
    const { appKey, keyName } = tencentMapKeys(tencentMapKey);
    if (window.qq) {
        geolocation = new window.qq.maps.Geolocation(appKey, keyName);
    }
    return geolocation;
}

function getLocation() {
    if (!geolocation) {
        initTencentLocation();
    }
    return new Promise((resolve, reject) => {
        geolocation.getLocation(
            data => {
                console.log(`current location: `, data);
                return resolve(data);
            },
            err => reject(err),
            { timeout: 10 * 1000 } // 10s
        );
    });
}

function openURL(url) {
    return (window.location.href = url);
}

export { getLocation, openURL };



// WEBPACK FOOTER //
// ./src/util/platform/h5.js